const rocznik = { t: 'Rocznik', type: 'range', name: 'rocznik', hint: { url: '/year' }}
export default rocznik